module.exports = __webpack_public_path__ + "img/read_xiao.9fac295f.png";